import "../App.css";

const Footer = () => {
  return (
    <>
      <footer>
        ©2022 Pixasso - Created by Paul and Mimoona for WBS
        <br />
      </footer>
    </>
  );
};

export default Footer;
